<div>
  <h2>Filtern nach</h2>
  <div class="filters-row">
    <div class="filters">
      <mat-form-field style="width: 150px">
        <mat-label>Jahr</mat-label>
        <mat-select
          [formControl]="yearFilterFormControl"
          name="year"
        >
          <mat-option [value]="allYears">Alle</mat-option>
          @for (year of (years$ | async); track year) {
            <mat-option
              [value]="year"
            >{{ year }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field style="min-width: 450px; flex-grow: 1">
        <mat-label>Vorgangstypen</mat-label>
        <mat-select
          [formControl]="typeFilterFormControl"
          name="vorgangstyp"
          multiple>
          @for (topping of typesFilter; track topping) {
            <mat-option
              [value]="topping">{{ topping | aufgabeTypeReadable }}
            </mat-option>
          }
        </mat-select>
        <button matSuffix mat-icon-button
                aria-label="Vorgangstyp-Auswahl leeren"
                (click)="typeFilterFormControl.setValue([])"
                data-qa="type-filter-clear-button"
        >
          <mat-icon svgIcon="innogy_picto_close"></mat-icon>
        </button>
      </mat-form-field>
      <mat-form-field style="width: 280px">
        <mat-label>Status</mat-label>
        <mat-select
          [formControl]="statusFilterFormControl"
          name="status"
          multiple>
          @for (status of statusFilter; track status) {
            <mat-option
              [value]="status">{{ status }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    <button
      matButton="outlined"
      (click)="resetFilter()"
      data-qa="reset-filter-button"
    >
      <mat-icon>autorenew</mat-icon>
      Filter zurücksetzen
    </button>
  </div>

  <div class="centered">
    <div class="lanes">

      @if (showCreated()) {
        <div
          class="lane"
        >
          <h2>Erstellte Vorgänge</h2>
          @if (aufgabenFiltered$ | async; as aufgaben) {
            @if (aufgaben.length > 0) {
              <div class="card-grid" data-qa="erstellt-von-aufgabe-liste">
                @for (aufgabe of aufgaben; track aufgabe.id) {
                    <ufla-aufgabe-card
                      tabindex="0"
                      role="link"
                      (click)="openDetails(aufgabe.id)"
                      (keydown.enter)="openDetails(aufgabe.id)"
                      [aufgabe]="aufgabe"
                      data-qa="ufla-aufgabe-card"
                    >
                    </ufla-aufgabe-card>
                }
              </div>
            } @else {
              <mat-card>
                <div class="empty-list"
                     data-qa="erstellt-von-aufgabe-liste-leer"
                >
                  <mat-icon>done_all</mat-icon>
                  <h2>Sie sind auf dem aktuellen Stand.</h2>
                  <div>Bisher haben Sie keine Aufgaben angelegt.</div>
                </div>
              </mat-card>
            }
          }
        </div>
        <div class="separator-lane"></div>
      }

      <div class="lane">
        <h2>Erhaltene Vorgänge</h2>
        @if (erhaltenFiltered$ | async; as erhalten) {
          @if (erhalten.length > 0) {
            <div class="card-grid" data-qa="erhaltene-vorgaenge-liste">
              @for (zuweisung of erhalten; track zuweisung.id) {
                  <ufla-zuweisung-card
                    tabindex="0"
                    role="link"
                    (click)="openZuweisung(zuweisung.id)"
                    (keydown.enter)="openZuweisung(zuweisung.id)"
                    [zuweisung]="zuweisung"
                    data-qa="ufla-zuweisung-card"
                  >
                  </ufla-zuweisung-card>
              }
              </div>
          } @else {
            <mat-card>
              <div class="empty-list"
                   data-qa="erhaltene-vorgaenge-liste-leer"
              >
                <mat-icon>done_all</mat-icon>
                <h2>Sie sind auf dem aktuellen Stand.</h2>
                <div>Bisher haben Sie keine Aufgaben erhalten.</div>
              </div>
            </mat-card>
          }
        }
      </div>

    </div>
  </div>
</div>
